import { Mutations } from "vuex-smart-module";
import { MutationTypes } from "../mutations-types";
import TargetsState from "./state";
import { IVessel, ISar, IAton, IBaseStation } from "./models";

export default class TargetsMutations extends Mutations<TargetsState> {
  [MutationTypes.SET_TARGETS](targetArray: Array<IVessel | ISar>) {
    this.state.vessels = targetArray.filter(
      (target) => target.type === "vessel"
    ) as IVessel[];
    this.state.sars = targetArray.filter(
      (target) => target.type === "sar"
    ) as ISar[];
  }
  [MutationTypes.SET_SELECTED_VESSEL](vessel: IVessel) {
    this.state.selectedVessel = vessel.mmsi;
  }
  [MutationTypes.SET_SELECTED_SAR](sar: ISar) {
    this.state.selectedSar = sar.mmsi;
  }
  [MutationTypes.ERASE_SELECTED_VESSEL]() {
    this.state.selectedVessel = 0;
  }
  [MutationTypes.ERASE_SELECTED_SAR]() {
    this.state.selectedSar = 0;
  }
  [MutationTypes.ERASE_SELECTED_TARGETS](){
    this.state.selectedVessel = 0;
    this.state.selectedSar = 0;
  }
  [MutationTypes.SET_PREDICTION_TIME](time:number) {
    this.state.predictionTime = time;
  }
  [MutationTypes.SET_ATONS]( atons:IAton[]) {
    this.state.atons = atons;
  }
  [MutationTypes.SET_BS]( baseStations:IBaseStation[]) {
    this.state.baseStations = baseStations;
  }
  [MutationTypes.CHANGE_TARGETS_TAG](status:boolean) {
    this.state.targetsTag = status
  }
}
